
import React, { useEffect, useState, useRef } from "react";

function StarFX({suspendFX}) {

  const numberOfRays = 40;
  const rayRotation = 360 / numberOfRays;
  const [rayStyles, setRayStyles] = useState(Array(numberOfRays));
  const fxContainerRef = useRef(null);

  const applyRayStyleArray = (e) => {
    let stylesArray = [...Array(numberOfRays)].map((e, i) => (
      {
        transform: `scaleY(${.3 + (Math.random() * .7)})`,
        transitionDuration: `${1 + (Math.random() * .5)}s`,
        opacity: Math.random()
      }
    ));
    setRayStyles(stylesArray);
  };

  const transitionEndHandler = (e) => {
    //if(!suspendFX) {
      newRayParams(e.target);
    //}
  };

  const newRayParams = (target) => {
    const randomValue = Math.random();
    target.style.transitionDuration = `${1 + (randomValue * .5)}s`;
    target.style.transform = `scaleY(${.3 + (randomValue * .7)})`;
    target.style.opacity = randomValue;
  }

  const unSuspend = () => {
    const targetEl = document.querySelectorAll('.starFXContainer .rayContainer .ray');
    //console.log(targetEl);
  }

  useEffect(() => {
    //console.log(suspendFX)
    if (!suspendFX) {
      unSuspend();
    }
  }, [suspendFX])

  useEffect(() => {
    applyRayStyleArray();
  }, []);

  return (
    <>
      <div className={`starFXContainer animateIn ${suspendFX ? 'suspended' : ''}`}>
        {[...Array(numberOfRays)].map((e, i) => (
          <div 
            className={`rayContainer`} 
            style={{ 
              transform: `rotate(${i * rayRotation}deg)`, 
              animationDelay: `${.3 + (i*.02)}s`}} 
            key={i}
            >
            <div 
              className="ray"
              style={rayStyles[i]}
              onTransitionEnd={transitionEndHandler}
            >
            </div>
          </div>
        ))}
      </div>
      <div className="missionRay"></div>
      
    </>
  );
};

export default StarFX;